import ObexRequestsHandlerP80 from '../handlers/ObexRequestsHandlerP80';
import { CostCenter, CostCenterPayload } from '../types/CostCenter.types';
import { getAccessToken, buildQuery, unwrapList, unwrapRecord, unwrapError } from './apiUtils';

// El backend solo expone list y create: los centros de coste no se editan ni
// se borran desde la aplicación.
const ROUTES = {
  list:   '/cost_centers_list',
  create: '/cost_centers_create'
};

export const mapCostCenter = (raw: any): CostCenter => ({
  id:          String(raw.id),
  companyId:   raw.company_id !== undefined && raw.company_id !== null ? String(raw.company_id) : '',
  companyName: raw.company_name || '',
  code:        raw.code || '',
  name:        raw.name || '',
  status:      raw.status === 'inactive' ? 'inactive' : 'active'
});

export const listCostCenters = async (
  options: { companyId?: string; status?: string; search?: string; page?: number; pageSize?: number } = {}
): Promise<CostCenter[]> => {
  const token = getAccessToken();
  if (!token) throw new Error('Sesión no válida o expirada.');

  const query = buildQuery({
    access_token: token,
    company_id:   options.companyId,
    status:       options.status,
    search:       options.search,
    page:         options.page || 1,
    page_size:    options.pageSize || 200
  });

  const res = await ObexRequestsHandlerP80.get(`${ROUTES.list}${query}`);
  return unwrapList(res).map(mapCostCenter);
};

export const createCostCenter = async (payload: CostCenterPayload): Promise<CostCenter> => {
  const token = getAccessToken();
  if (!token) throw new Error('Sesión no válida o expirada.');

  const query = buildQuery({
    access_token: token,
    company_id:   payload.companyId,
    code:         payload.code,
    name:         payload.name,
    status:       payload.status || 'active'
  });

  const res = await ObexRequestsHandlerP80.get(`${ROUTES.create}${query}`);
  const record = unwrapRecord(res);
  if (!record) throw new Error(unwrapError(res, 'Error al dar de alta el centro de coste.'));
  return mapCostCenter(record);
};
